module.exports = __webpack_public_path__ + "static/media/mouthDimpleRight.0eb80455.obj";